Object.defineProperty(exports, "__esModule", { value: true });
var carouselFormatters = {
    getAltText: function (_a) {
        var data = _a.data, index = _a.index;
        return data.caption || index + 1 + ". k\u00E9p";
    },
    getNextLabel: function (_a) {
        var currentIndex = _a.currentIndex, views = _a.views;
        return "Mutasd a(z) " + (currentIndex + 2) + ". k\u00E9pet a(z) " + views.length + " k\u00F6z\u00FCl";
    },
    getPrevLabel: function (_a) {
        var currentIndex = _a.currentIndex, views = _a.views;
        return "Mutasd a(z) " + currentIndex + ". k\u00E9pet a(z) " + views.length + " k\u00F6z\u00FCl";
    },
    getNextTitle: function () { return 'Következő (jobbra nyíl)'; },
    getPrevTitle: function () { return 'Előző (balra nyíl)'; },
    getCloseLabel: function () { return 'Bezárás (esc)'; },
    getFullscreenLabel: function (_a) {
        var isFullscreen = _a.isFullscreen;
        return isFullscreen
            ? 'Kilépés a teljes képernyős nézetből (f)'
            : 'Teljes képernyőre váltás (f)';
    },
};
exports.default = carouselFormatters;
